export const auth = {
  title: "Grizzly Industries",
  subtitle: "تسجيل الدخول إلى عمليات المتجر",
  email: "البريد الإلكتروني",
  passwordLabel: "كلمة المرور",
  signIn: "تسجيل الدخول",
  signingIn: "جارٍ تسجيل الدخول…",
  unreachable: "تعذّر الوصول إلى خادم المتجر. تحقق من الاتصال وحاول مرة أخرى.",
  demoHint:
    "حسابات التطوير: owner@grizzly.local و office@grizzly.local و operator@grizzly.local (كلمة المرور Grizzly!dev123)",
};
